export default {
    methods: {
        validate() {
            this.$store.state.validated = true;

            let isValid = true;
            const self = this;

            if (this.subtotal === 0) {
                this.scrollToTarget(document.querySelector('.table.products'));
                isValid = false;
            }
            document.querySelectorAll('.contact-info-form .form-group.required')
                .forEach(function (element) {
                    const value = element.querySelector('.form-control').value;

                    if (value.length === 0) {
                        if (isValid) self.scrollToTarget(element);
                        isValid = false;
                    }
                });

            if (!this.$store.state.form.payment_method) {
              isValid = false;
            }

            return isValid;
        },
    },
}
